export const coordinatesToString = (coordinates: { latitude: number; longitude: number }): string => {
  const latitude = coordinates.latitude.toFixed(6)
  const longitude = coordinates.longitude.toFixed(6)
  return `${latitude}º N, ${longitude}º W`
}

export const isValidLatAndLong = (lat: number | string, lon: number | string): boolean => {
  const num1 = '' + lat
  const num2 = '' + lon
  if (parseFloat(num1) <= 90 && parseFloat(num1) >= -90 && parseFloat(num2) <= 180 && parseFloat(num2) >= -180) {
    return true
  } else {
    return false
  }
}
